import { Box, Button, Grid, InputAdornment } from "@material-ui/core";
import {
    DurationType,
    durationTypeDescription,
    RoundDefault,
    StatusRound,
    useOnSubmitFormik,
} from "api";
import { Round } from "api/model";
import { Form, Formik } from "formik";
import { DateTime } from "luxon";
import React from "react";
import {
    DateFieldFormik,
    InputFieldFormik,
    SelectFieldFormik,
    SelectOption,
    SelectTrack,
    SubmitButton,
    yupMinValueField,
    yupRequiredField,
} from "ui/componentes";
import { Info } from "@material-ui/icons";
import { SelectTrackCourse } from "ui/componentes/SelectTrack/SelectTrackCourse";
import * as Yup from "yup";

const durationTypeOptions: SelectOption[] = [
    {
        label: durationTypeDescription(DurationType.LAPS),
        value: DurationType.LAPS,
    },
    {
        label: durationTypeDescription(DurationType.MINUTES),
        value: DurationType.MINUTES,
    },
];

interface RaceFormProps {
    round?: Round;
    championshipId: string;
    seasonId: string;
    onCancel: () => void;
}

const initialValues = (championshipId, seasonId): Round => ({
    championshipId,
    seasonId,
    date: DateTime.local().toFormat("yyyy-MM-dd"),
    trackName: "",
    status: StatusRound.CREATED,
    durationType: DurationType.MINUTES,
    duration: 0,
    trackId: "",
    trackCourse: "",
    multiplyPointsBy: 1,
});

export const RoundFormValidation = Yup.object().shape({
    championshipId: Yup.string().required(yupRequiredField),
    date: Yup.string().required(yupRequiredField),
    trackId: Yup.string().required(yupRequiredField),
    trackCourse: Yup.string().required(yupRequiredField),
    multiplyPointsBy: Yup.number()
        .required(yupRequiredField)
        .min(1, yupMinValueField),
});

const RoundForm: React.FC<RaceFormProps> = ({
    championshipId,
    round,
    onCancel,
    seasonId,
}) => {
    const onSubmit = useOnSubmitFormik<Round>("rounds", {
        callback: (id, resetForm) => {
            onCancel();
            resetForm();
        },
    });

    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                ...RoundDefault,
                ...initialValues(championshipId, seasonId),
                ...round,
            }}
            validationSchema={RoundFormValidation}
            onSubmit={onSubmit}
        >
            {({ values, resetForm }) => {
                return (
                    <Form>
                        <Grid container spacing={1}>
                            <Grid item md={2} xs={12}>
                                <DateFieldFormik
                                    required
                                    id="date"
                                    name="date"
                                    label="Data da etapa"
                                    fieldType="keyboardDatePicker"
                                />
                            </Grid>
                            <Grid item md={2} xs={12}>
                                <SelectFieldFormik
                                    id="durationType"
                                    name="durationType"
                                    label="Duração em"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment
                                                position="start"
                                                title="Os campos 'Duração em' e 'Minutos / Voltas' serão utilizados quando houver somente uma bateria configurada"
                                            >
                                                <Info />
                                            </InputAdornment>
                                        ),
                                    }}
                                    options={durationTypeOptions}
                                />
                            </Grid>
                            <Grid item md={2} xs={12}>
                                <InputFieldFormik
                                    id="duration"
                                    name="duration"
                                    label={durationTypeDescription(
                                        values.durationType
                                    )}
                                    type="number"
                                />
                            </Grid>
                            <Grid item md={2} xs={12}>
                                <InputFieldFormik
                                    id="multiplyPointsBy"
                                    name="multiplyPointsBy"
                                    label="Multiplicar pontos por"
                                    type="number"
                                />
                            </Grid>
                            <Grid item xs={4} />
                            <Grid item md={4} xs={12}>
                                <SelectTrack name="trackId" />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <SelectTrackCourse
                                    name="trackCourse"
                                    trackId={values.trackId}
                                />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <Box marginTop={1} display="flex">
                                    <SubmitButton />
                                    <Button
                                        onClick={() => {
                                            onCancel();
                                            resetForm();
                                        }}
                                        style={{ marginLeft: 5 }}
                                    >
                                        Cancelar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                );
            }}
        </Formik>
    );
};

export { RoundForm };
